import { NavLink } from "react-router-dom";
import { Home, Users, Heart, Play, Menu } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Home", Icon: Home },
  { to: "/candidates", label: "Candidates", Icon: Users },
  { to: "/vote", label: "Vote", Icon: Heart, primary: true },
  { to: "/watch", label: "Watch", Icon: Play },
  { to: "/more", label: "More", Icon: Menu },
];

export default function MobileNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex h-16 items-center justify-around border-t border-gold/30 bg-black/90 backdrop-blur-xl xl:hidden"
      data-testid="mobile-bottom-nav"
    >
      {ITEMS.map(({ to, label, Icon, primary }) =>
        primary ? (
          <NavLink key={to} to={to} data-testid="mobile-nav-vote" className="relative -mt-8 flex flex-col items-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full gold-bg text-obsidian shadow-[0_0_18px_rgba(230,0,92,0.6)]">
              <Icon className="h-6 w-6" />
            </span>
            <span className="mt-1 text-[0.6rem] font-bold uppercase tracking-wider text-gold">{label}</span>
          </NavLink>
        ) : (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={`mobile-nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 ${isActive ? "text-gold" : "text-amber-50/60"}`
            }
          >
            <Icon className="h-5 w-5" />
            <span className="text-[0.6rem] uppercase tracking-wider">{label}</span>
          </NavLink>
        )
      )}
    </nav>
  );
}
